/* eslint-disable no-unexpected-multiline */
/* eslint-disable no-undef */
import images from 'assets/images/images'
import SimpleAccordion from 'components/accordion/SimpleAccordion'
import useTranslate from 'hooks/useTranslate'
//import SwitchToggle from 'components/form-elements/switchToggle/SwitchToggle'
import React, { useState } from 'react'
// import {dataLayerPush} from 'utils/Datalayer'

const Cookie = ({setCookieOpen, setCookieValues, cookieValues}) => {
	const [customized, setCustomized] = useState(false)
  const {t} = useTranslate()
  const saveCookie = (type) => {
    setCookieOpen(false);
    
    let cookieSaved = {
      'functionality_storage': 'granted',
    };
    
    if (type === 'acceptAll') {
      cookieSaved = {
        ...cookieSaved,
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'analytics_storage': 'granted',
        'ad_personalization': 'granted'
      };
    } else if (type === 'acceptAndSave') {
      cookieSaved = {
        ...cookieSaved,
        'ad_storage': cookieValues.ad_storage,
        'ad_user_data': cookieValues.ad_user_data,
        'analytics_storage': cookieValues.analytics_storage,
        'ad_personalization': cookieValues.ad_personalization
      };
    } else { // reject
      cookieSaved = {
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'analytics_storage': 'denied',
        'functionality_storage': 'denied',
        'ad_personalization': 'denied',
      };
    }
    
    localStorage.setItem('cookies', JSON.stringify(cookieSaved));
    
    // GTM'e consent güncellemesini gönder
    const gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };
    gtag('consent', 'update', cookieSaved);
    
    // Ek olarak dataLayer event'i de gönderebilirsiniz
    window.dataLayer.push({
      'event': 'consent_update',
      ...cookieSaved
    });
  }
  const onCHangeCookie = (e) => {
    setCookieValues(prev => ({...prev, [e.target.name]: e.target.checked == true ? 'granted':'denied' }))
  }
	return (
		<div className='cookie-last'>
			{customized ? (
				<div className='cookie-last-container'>
                    <div className='cookie-last-container-customizeTitle'>
                         <div className='header-m'>{t('cookieTitle')}</div>
                         <img onClick={() => setCustomized(!customized)} src={images.close} alt="" />
                    </div>
                    <div className='body-s mt-3 mb-2'>
                      {t('cookieParagraph1')}
                    </div>
                     <div className='accordionCont'>
                     <SimpleAccordion
                    //switchOpen = {true}
                    header={
                      <div className="cookie-last-container-customizeTitleText">
                        <div className='cookie-title header-m'>
                          {t('cookieSubtitle1')}
                        </div>
                         {/* <div className='mr-3'>
                          <SwitchToggle />
                        </div>  */}
                      </div>
                    }
                    content={<div className="body-s">
                      {t('cookieParagraph2')}
                    </div>}
                  />
                     </div>
                   
                    <div className='accordionCont'>
                    <SimpleAccordion
                      switchOpen = {true}
                      onCheckboxChange={onCHangeCookie}
                      checkboxName='analytics_storage'
                      header={
                        <div className="cookie-last-container-customizeTitleText">
                          <div className='cookie-title header-m'>
                            {t('cookieSubtitle2')}
                          </div>
                          {/* <div className='mr-3'>
                            <SwitchToggle />
                          </div>  */}
                        </div>
                      }
                    content={<div className="body-s">
                     {t('cookieParagraph3')}
                    </div>}
                  />
                    </div>
                 
                   
                   <div className='accordionCont'>
                   <SimpleAccordion
                    switchOpen = {true}
                    header={
                      <div className="cookie-last-container-customizeTitleText">
                        <div className='cookie-title header-m'>
                        {t('cookieSubtitle4')}
                        </div>
                         {/* <div className='mr-3'>
                          <SwitchToggle />
                        </div>  */}
                      </div>
                    }
                    checkboxName='ad_user_data'
                    onCheckboxChange={onCHangeCookie}
                    content={<div className="body-s">
                      {t('cookieParagraph5')}
                    </div>}
                  />
                   </div>
                  
                  <div className='accordionCont'>
                  <SimpleAccordion
                    switchOpen = {true}
                     onCheckboxChange={onCHangeCookie}
                    checkboxName='ad_storage'
                    header={
                      <div className="cookie-last-container-customizeTitleText">
                        <div className='cookie-title header-m'>
                        {t('cookieSubtitle5')}
                        </div>
                         {/* <div className='mr-3'>
                          <SwitchToggle />
                        </div>  */}
                      </div>
                    }
                    content={<div className="body-s">
                      {t('cookieParagraph6')}
                    </div>}
                  />
                  </div>
                  
                  <div className='accordionCont'>
                  <SimpleAccordion
                    switchOpen = {true}
                    checkboxName='ad_personalization'
                    onCheckboxChange={onCHangeCookie}
                    header={
                      <div className="cookie-last-container-customizeTitleText">
                        <div className='cookie-title header-m'>
                        {t('moreBtn')}
                        </div>
                         {/* <div className='mr-3'>
                          <SwitchToggle />
                        </div>  */}
                      </div>
                    }
                    content={<div className="body-s">
                      {t('cookieParagraph7')}
                    </div>}
                  />
                  </div>
                  <div onClick={() => saveCookie('acceptAndSave')
                  // .finally(() => {
                  //    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                  //     new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                  //     j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                  //     'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                  //     })(window,document,'script','dataLayer','GTM-5D5MF3P');
                  // })
                  } className='customizedBtn'>
                    {t('acceptAndSaveBtn')}
                  </div>
                </div>
			) : (
				<div className='cookie-last-container'>
					<div className='cookie-last-container-img'>
          <div className='header-m'>{t('cookieTitle')}</div>
						<img onClick={saveCookie} src={images.close} alt='' />
					</div>
					<div className='cookie-last-container-text'>
          {t('cookieParagraph8')}
					</div>
					<div className='cookie-last-container-btngroup'>
						<div onClick={() => setCustomized(!customized)} className='cookie-last-container-btngroup-btn'>
              {t('customizeBtn')}
						</div>
						<div onClick={() => saveCookie('reject')
            // .finally(() => {
            //    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            //     new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            //     j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            //     'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            //     })(window,document,'script','dataLayer','GTM-5D5MF3P');
            // })
            } className='cookie-last-container-btngroup-btn'>{t('rejectAllBtn')}</div>
						<div onClick={() => saveCookie('acceptAll')
            // .finally(() => {
            //    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            //     new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            //     j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            //     'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            //     })(window,document,'script','dataLayer','GTM-5D5MF3P');
            // })
            } className='cookie-last-container-btngroup-btn'>{t('acceptAllBtn')}</div>
					</div>
				</div>
			)}
		</div>
	)
}

export default Cookie
